import { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ReactLoading from "react-loading";
import { Customer } from "./Customer";
import { Premix } from "./Premix";
import { Enzymes } from "./Enzymes";
import { Health } from "./Health";
import { Minerals } from "./Minerals";
import { Additions } from "./Additions";
import Matriz from "assets/icons/matriz.png";
import { getInitialObject } from "utils/globalFunctions";
import { api } from "services/api";
import { Modal } from "components/Modal";
import { Button } from "components/Button";
import UpdateList from "contexts/updateList";

export function CreateEdit(props) {
  const { setUpdateList } = useContext(UpdateList);

  const heavyBroilerInit = {
    _id: null,
    date: "",
    accommodations: "",
    healthScore: "",
    healthChallenge: "",
    knownAgents: "",
    antibiogramRecent: "",
    export: false,
    internMarket: false,
    exportCuts: "",
    exportPlaces: [],
    premixProductionYear: "",
    premixComposition: "",
    premixPlaxma: false,
    premixHemoglobin: false,
    premixAnimalFeed: false,
    premixAnimalFeedType: "",
    premixSteps: {
      create: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      recreate: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      production: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
    },
    enzymes: {
      phytase: {
        create: {
          checked: false,
          product: "",
        },
        recreate: {
          checked: false,
          product: "",
        },
        production: {
          checked: false,
          product: "",
        },
      },
      phytaseHidosing: {
        create: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        recreate: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        production: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        approved: {
          checked: false,
          reason: "",
        },
      },
      carbohydraseBlends: {
        create: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        recreate: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        production: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        approved: {
          checked: false,
          reason: "",
        },
      },
      enziPacProProtease: {
        create: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        recreate: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        production: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        approved: {
          checked: false,
          reason: "",
        },
      },
    },
    health: {
      anticoccidian: {
        qualipac: false,
        action: "",
        why: "",
        moleculeCreate: "",
        moleculeRecreate: "",
        moleculeProduction: "",
        rotation: "",
        powderGranular: "",
        additional: false,
      },
      therapeuticMedication: {
        create: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        recreate: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        production: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
      },
      performanceEnhancer: {
        create: {
          checked: false,
          product: "",
          from: "",
          to: "",
        },
        recreate: {
          checked: false,
          product: "",
          from: "",
          to: "",
        },
        production: {
          checked: false,
          product: "",
          from: "",
          to: "",
        },
      },
    },
    minerals: {
      organics: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
        unknownConcept: false,
      },
      zincOxide: {
        create: {
          checked: false,
          ppm: "",
        },
        recreate: {
          checked: false,
          ppm: "",
        },
        production: {
          checked: false,
          ppm: "",
        },
      },
      copperSulfate: {
        create: {
          checked: false,
          ppm: "",
        },
        recreate: {
          checked: false,
          ppm: "",
        },
        production: {
          checked: false,
          ppm: "",
        },
      },
    },
    additions: {
      organicAcids: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
        unknownConcept: false,
      },
      mycotoxinAdsorbents: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
        unknownConcept: false,
      },
      essencialOils: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
      },
      prebiotics: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
      },
      probiotics: {
        create: {
          checked: false,
          product: "",
          reason: "",
        },
        recreate: {
          checked: false,
          product: "",
          reason: "",
        },
        production: {
          checked: false,
          product: "",
          reason: "",
        },
      },
      others: {
        emulsifiers: false,
        pigmentation: false,
        pigmentationType: "",
        create: {
          yellowppm: "",
          redppm: "",
        },
        recreate: {
          yellowppm: "",
          redppm: "",
        },
        production: {
          yellowppm: "",
          redppm: "",
        },
      },
    },
  };

  const [loading, setLoading] = useState(true);

  const [heavyBroiler, setHeavyBroiler] = useState(heavyBroilerInit);

  const [config, setConfig] = useState([]);

  const [getHeavyBroiler, setGetHeavyBroiler] = useState(true);

  const [tab, setTab] = useState(0);

  const saveHeavyBroiler = async (e) => {
    const requestHeavyBroiler = { ...heavyBroiler };
    requestHeavyBroiler.customer = props.customer;
    if (!requestHeavyBroiler._id) {
      const response = await Swal.fire({
        title: "Criar Produção de Matriz Pesada",
        text: "Deseja confirmar criação?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0451e8",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Criar!",
        showLoaderOnConfirm: true,
        preConfirm: async () =>
          await api
            .post("heavybroilerhistoric", requestHeavyBroiler)
            .catch((err) => ({
              err: true,
              data: { message: err.response.data.message },
            })),
      });
      if (response.value) {
        Swal.fire(
          "Criar Produção de Matriz Pesada",
          response.value.data.message,
          response.value.err ? "error" : "success"
        );
      }
      setUpdateList(true);
    } else {
      const response = await Swal.fire({
        title: "Editar Produção de Matriz Pesada",
        text: "Deseja confirmar edição?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0451e8",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Editar!",
        showLoaderOnConfirm: true,
        preConfirm: async () =>
          await api
            .put(
              "heavybroilerhistoric/" + requestHeavyBroiler._id,
              requestHeavyBroiler
            )
            .catch((err) => ({
              err: true,
              data: { message: err.response.data.message },
            })),
      });

      if (response.value) {
        Swal.fire(
          "Editar Produção de Matriz Pesada",
          response.value.data.message,
          response.value.err ? "error" : "success"
        );
      }
      setUpdateList(true);
    }
  };

  useEffect(() => {
    const loadHeavyBroiler = async () => {
      setLoading(true);
      const responseConfig = await api.get("broilerhistoric/config", {
        params: {
          query:
            "premixComposition premixAnimalFeedType premixPhysicalForm premixCommonDescription " +
            "customerHealthScore customerExportCuts enzymesPhytaseProduct enzymesPhytaseType " +
            "enzymesCarbohydraseBlendsProduct enzymesEnziPacProProteaseProduct healthAnticoccidianMolecule " +
            "healthTherapeuticMedicationType healthTherapeuticMedicationProduct healthPerformanceEnhancerProduct " +
            "mineralsOrganicsProduct additionsOrganicAcidsProduct additionsMycotoxinAdsorbentsProduct " +
            "additionsEssencialOilsProduct additionsPrebioticsProduct additionsProbioticsProduct othersPigmentationType",
        },
      });

      if (!responseConfig.data) {
        Swal.fire(
          "Editar Configurações",
          "Não foi possível buscar configurações",
          "error"
        );
      }
      setConfig([...responseConfig.data]);
      const response = await api.get(
        props.id
          ? `heavybroilerhistoric/edit/${props.id}`
          : `heavybroilerhistoric/${props.customer}`
      );
      if (!response.data) {
        return setLoading(false);
      }
      const heavyBroilerCopy = getInitialObject(
        { ...heavyBroiler },
        response.data
      );

      setHeavyBroiler(heavyBroilerCopy);
      setLoading(false);
    };
    if (getHeavyBroiler) {
      setGetHeavyBroiler(false);
      loadHeavyBroiler();
    }
  }, [heavyBroiler, getHeavyBroiler, props]);

  return (
    <Modal
      show={props.show}
      close={() => props.setShow(false)}
      header={
        <>
          <img src={Matriz} style={{ width: "30px" }} alt="matriz pesada" />
          <h2>Histórico - Matriz Pesado</h2>
        </>
      }
      footer={
        <Button
          color="white"
          bg="default"
          border="default"
          onClick={saveHeavyBroiler}
        >
          Salvar
        </Button>
      }
    >
      {loading ? (
        <ReactLoading type="spin" color="#009870" height={30} width={30} />
      ) : (
        <>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, value) => {
              setTab(value);
            }}
          >
            <Tab label="Cliente" />
            <Tab label="Premix/Ração" />
            <Tab label="Enzimas" />
            <Tab label="Saúde" />
            <Tab label="Minerais" />
            <Tab label="Aditivos" />
          </Tabs>
          {tab === 0 && (
            <Customer
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
              editing={props.editing}
            />
          )}
          {tab === 1 && (
            <Premix
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
            />
          )}
          {tab === 2 && (
            <Enzymes
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
            />
          )}
          {tab === 3 && (
            <Health
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
            />
          )}
          {tab === 4 && (
            <Minerals
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
            />
          )}
          {tab === 5 && (
            <Additions
              heavyBroiler={heavyBroiler}
              setHeavyBroiler={setHeavyBroiler}
              config={config}
            />
          )}
        </>
      )}
    </Modal>
  );
}
